
<ion-row class="pt-10">
  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-between">
        <ion-col size-sm="12" size-md="10" size-lg="10" size-xs="12">
          <div class="fs-16 font_bold">Salary Range</div>
        </ion-col>
  
        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <div class="d-flex graph-icon">
            <span (click)="salaryRangeChart('bar')">
              <img *ngIf="isSalaryRangeChartIcon != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
              <img *ngIf="isSalaryRangeChartIcon == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
            </span>
            <span (click)="salaryRangeChartTable()">
              <img *ngIf="!isSalaryRangeTable" src="./assets/icon/tableIcon.svg" alt="" class="cp">
              <img *ngIf="isSalaryRangeTable" src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span (click)="salaryRangeChart('line')">
              <img *ngIf="isSalaryRangeChartIcon != 'line'" src="./assets/icon/lineChartIcon.svg" alt="" class="cp">
              <img *ngIf="isSalaryRangeChartIcon == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <span>
              <img (click)="downloadChartAsPDF('Salary Range Attrition', 'first')" src="./assets/icon/downloadIcon.svg" alt="" class="cp">
            </span>
          </div>
        </ion-col>
      </ion-row>
  
      <ion-row class="">
        <ion-col size="5" size-md="5" size-lg="5" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency1"
                    (selectionChange)="onYearChange($event.value,'first')">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col>
                  <mat-form-field class="mat-height40 w-100  mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedMonth1"
                    (selectionChange)="onMonthChange($event, 'first')">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>
  
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div [ngClass]="{'dispNone' : !isSalaryRangeTable}">
          <div class="dashboardGraphTable">
            <table id="table-Salary-Range-data">
              <thead>
                <tr class="custom-size">
                  <th>Salary Range</th>
                  <th>Attrition Count</th>
                  <th>Attrition %</th>
                  <th>Annualized Attrition %</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of isSalaryRangeTableGraph">
                  <td>{{data.xAxisValueData}}</td>
                  <td>{{data.seriesValueOneData}}</td>
                  <td>{{data.seriesValueTwoData}}</td>
                  <td>{{data.seriesValueThreeData}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div [ngClass]="{'dispNone' : isSalaryRangeTable}" id="salary-range-chart" style="width: 1000px; height: 400px;"></div>
      </ion-col>
    </div>
  </ion-col>
</ion-row>

<ion-row class="pt-10">
    <ion-col size="12">
      <div class="graphs card m-50">
        <ion-row class="justify-content-between">
          <ion-col size-sm="12" size-md="10" size-lg="10" size-xs="12" class="">
            <div class="fs-16 font_bold">Reason for exit </div>
          </ion-col>
          <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
            <div class="d-flex graph-icon">
              <span>
                <img src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
              </span>
              
              <span (click)="switchGraphType('line')">
                <img *ngIf="graphType != 'line'" src="./assets/icon/lineChartIcon.svg" alt="">
                <img *ngIf="graphType == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img src="./assets/icon/TableIconActive.svg" alt="">
              </span>
              <span class="cp" (click)="downloadGraph()">
                <img src="./assets/icon/downloadIcon.svg" alt="">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="">
          <ion-col size="5" size-md="5" size-lg="5" size-xs="12">
            <div class="sidebar-content">
              <ion-grid>
                <ion-row>
                  <ion-col>
                    <div class="formLabelRegularfs16  ">
                      Year<span class="red-cl">&nbsp;*</span></div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency2"
                      (selectionChange)="onYearChange($event.value,'second')">
                        <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                          {{sharedService.transformYearToFyFormat(item.year)}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                  <ion-col>
                    <div class="formLabelRegularfs16">
                      Month<span class="red-cl">&nbsp;*</span>
                    </div>
                    <mat-form-field class="mat-height40 w-100  mat-input-style">
                      <mat-select placeholder="Select" [(ngModel)]="selectedMonth2"
                      (selectionChange)="onMonthChange($event, 'second')">
                        <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                      </mat-select>
                    </mat-form-field>
  
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </ion-col>
        </ion-row>
        <div id="AgeGenderGraph" style="width: 100%; height: 400px;"></div>

      </div>
    </ion-col>
</ion-row>

<ion-row class="pt-10">

   
    <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
      <div class="graphs card m-50">
        <ion-row class="justify-content-center">
          <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
            <div class="fs-16 font_bold">Increment %</div>
          </ion-col>
  
          <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
            <div class="d-flex graph-icon">
              <span (click)="incrementRate('bar')">
                <img *ngIf="isIncrementRateIcon != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isIncrementRateIcon == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="incrementRateTable()">
                <img *ngIf="!isIncrementRateTable" src="./assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isIncrementRateTable" src="./assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="incrementRate('line')">
                <img *ngIf="isIncrementRateIcon != 'line'" src="./assets/icon/lineChartIcon.svg" alt="" class="cp">
                <img *ngIf="isIncrementRateIcon == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
              </span>
              <span class="cp" (click)="incrementRate('pie')">
                <img src="./assets/icon/pieChartIcon.svg" *ngIf="isIncrementRateIcon!='pie'">
                <img src="./assets/icon/activePieChartIcon.svg" *ngIf="isIncrementRateIcon=='pie'">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Increment Attrition','three')" src="./assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
  
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="sidebar-content">
              <ion-grid>
                <ion-row>
                  <ion-col size="4">
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency3"
                      (selectionChange)="onYearChange($event.value,'three')">
                        <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                          {{sharedService.transformYearToFyFormat(item.year)}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                  <!-- <ion-col size="4">
                    <mat-form-field class="mat-height40 w-100 mat-input-style">
                      <mat-select placeholder="Select Month" [(ngModel)]="selectedMonth"
                        (selectionChange)="onMonthChange($event)">
                        <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col> -->
                </ion-row>
              </ion-grid>
            </div>
          </ion-col>
        </ion-row>
  
        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div [ngClass]="{'dispNone' : !isIncrementRateTable}">
            <div class="dashboardGraphTable">
              <table id="table-Increment-Attrition-data">
                <thead>
                  <tr class="custom-size">
                    <th>Increment</th>
                    <th>Count</th>
                    <th>Attrition%</th>
                    <th>Annualized Attrition%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of isIncrementTableGraph">
                    <td>{{data.xAxisValueData}}</td>
                    <td>{{data.seriesValueOneData}}</td>
                    <td>{{data.seriesValueTwoData}} </td>
                    <td>{{data.seriesValueThreeData}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div [ngClass]="{'dispNone' : isIncrementRateTable}" id="increment-chart"
            style="width: 500px; height: 400px;"></div>
        </ion-col>
      </div>
    </ion-col>
  
<!-- 
    <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
      <div class="graphs card m-50">
        <ion-row class="justify-content-center">
          <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
            <div class="fs-16 font_bold">VP amount</div>
          </ion-col>
          <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
            <div class="d-flex graph-icon">
              <span>
                <img src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
              </span>
              
              <span (click)="switchGraphType('line')">
                <img *ngIf="graphType != 'line'" src="./assets/icon/lineChartIcon.svg" alt="">
                <img *ngIf="graphType == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img src="./assets/icon/TableIconActive.svg" alt="">
              </span>
              <span>
                <img src="././assets/icon/pieChartIcon.svg" alt="Pie Chart" class="cp">
              </span>
              <span class="cp" (click)="downloadGraph()">
                <img src="./assets/icon/downloadIcon.svg" alt="">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="sidebar-content">
              <ion-grid>
                <ion-row>
                  <ion-col size="4">
                    <div class="formLabelRegularfs16   mb-5">
                      Year<span class="red-cl">&nbsp;*</span></div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                        (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                        <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                          {{sharedService.transformYearToFyFormat(item.year)}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                  <ion-col size="4" >
                    <div class="formLabelRegularfs16   mb-5">
                      Freq.<span class="red-cl">&nbsp;*</span></div>
                  <div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Frequency" [(ngModel)]="setupFrequency" [disabled]="isVPSetupDone"
                        (selectionChange)="updatePeriodOptions($event);clearCutOffDays();getPrevYearSetupVP();">
                        <mat-option *ngFor="let frequency of filteredFrequencies" [value]="frequency">
                          {{ frequency }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  </ion-col>
  
                  <ion-col size="4" >
                    <div class="formLabelSemiBoldfs14 mb-5">{{ frequencyName === 'Semi_Annually' ? 'Semi-Annually' :
                      setupFrequency }}<span class="red-cl">&nbsp;*</span>
                    </div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Period"
                        (selectionChange)="onPeriodChange($event);clearCutOffDays();" [(ngModel)]="frequencyPeriod">
                        <mat-option *ngFor="let months of setupMonths" [value]="months">
                          {{ months }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
  
                  </ion-col>
  
  
                </ion-row>
              </ion-grid>
            </div>
          </ion-col>
        </ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div id="bar-line-approvedByFinance-chart" style="width: 100%; height: 400px;"></div>
        </ion-col>
      </div>
    </ion-col> -->
    <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
      <div class="graphs card m-50">
        <ion-row class="justify-content-center">
          <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
            <div class="fs-16 font_bold">VP Amount</div>
          </ion-col>
    
          <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
            <div class="d-flex graph-icon">
              <span (click)="vpAmountRate('bar')">
                <img *ngIf="isVPAmountIcon != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isVPAmountIcon == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="vpAmountRateTable()">
                <img *ngIf="!isVPAmountTable" src="./assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isVPAmountTable" src="./assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="vpAmountRate('line')">
                <img *ngIf="isVPAmountIcon != 'line'" src="./assets/icon/lineChartIcon.svg" alt="" class="cp">
                <img *ngIf="isVPAmountIcon == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
              </span>
              <span class="cp" (click)="vpAmountRate('pie')">
                <img src="./assets/icon/pieChartIcon.svg" *ngIf="isVPAmountIcon!='pie'">
                <img src="./assets/icon/activePieChartIcon.svg" *ngIf="isVPAmountIcon=='pie'">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('VP Amount','four')" src="./assets/icon/downloadIcon.svg" alt="" class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
    
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="sidebar-content">
              <ion-grid>
                <ion-row>
                  <ion-col size="4">
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency4"
                      (selectionChange)="onYearChange($event.value,'four')">
                        <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                          {{sharedService.transformYearToFyFormat(item.year)}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                  <ion-col size="4">
                    <!-- <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Frequency" [(ngModel)]="setupFrequency" [disabled]="isVPSetupDone"
                        (selectionChange)="updatePeriodOptions($event);clearCutOffDays();getPrevYearSetupVP();">
                        <mat-option *ngFor="let frequency of filteredFrequencies" [value]="frequency">
                          {{ frequency }} 
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <div class="formLabelSemiBoldfs14 mb-5">{{ frequencyName === 'Semi_Annually' ? 'Semi-Annually' :
                      setupFrequency }}<span class="red-cl">&nbsp;*</span>
                    </div> -->
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Period"
                        (selectionChange)="onPeriodChange($event);clearCutOffDays();" [(ngModel)]="frequencyPeriod">
                        <mat-option *ngFor="let months of setupMonths" [value]="months">
                          {{ months }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </ion-col>
        </ion-row>
    
        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div [ngClass]="{'dispNone' : !isVPAmountTable}">
            <div class="dashboardGraphTable">
              <table id="table-VP-Amount-data">
                <thead>
                  <tr class="custom-size">
                    <th>VP Amount</th>
                    <th>Count</th>
                    <th>Percentage</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of isVPAmountTableGraph">
                    <td>{{data.xAxisValueData}}</td>
                    <td>{{data.seriesValueOneData}}</td>
                    <td>{{data.seriesValueTwoData}} </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div [ngClass]="{'dispNone' : isVPAmountTable}" id="vpamount-chart" style="width: 500px; height: 400px;"></div>
        </ion-col>
      </div>
    </ion-col>
    
</ion-row>



<ion-row class="pt-10">

  <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-center">
        <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
          <div class="fs-16 font_bold">No. of unplanned leaves taken in past 3 months</div>
        </ion-col>
        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div class="d-flex graph-icon">
            <span>
              <img src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
            </span>
            
            <span (click)="switchGraphType('line')">
              <img *ngIf="graphType != 'line'" src="./assets/icon/lineChartIcon.svg" alt="">
              <img *ngIf="graphType == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <span>
              <img src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span>
              <img src="././assets/icon/pieChartIcon.svg" alt="Pie Chart" class="cp">
            </span>
            <span class="cp" (click)="downloadGraph()">
              <img src="./assets/icon/downloadIcon.svg" alt="">
            </span>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <div class="formLabelRegularfs16   mb-5">
                    Year<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency5"
                    (selectionChange)="onYearChange($event.value,'five')">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="4">
                  <div class="formLabelRegularfs16   mb-5">
                    Month<span class="red-cl">&nbsp;*</span>
                  </div>
                  <mat-form-field class="mat-height40 w-100  mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedMonth5"
                    (selectionChange)="onMonthChange($event, 'five')">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                </ion-col>

              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xl="12">
        <div id="bar-line-chart" style="width: 100%; height: 400px;"></div>
      </ion-col>
    </div>
  </ion-col>


  <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-center">
        <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
          <div class="fs-16 font_bold">Late comming in past 3 Months</div>
        </ion-col>
        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div class="d-flex graph-icon">
            <span>
              <img src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
            </span>
            
            <span (click)="switchGraphType('line')">
              <img *ngIf="graphType != 'line'" src="./assets/icon/lineChartIcon.svg" alt="">
              <img *ngIf="graphType == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <span>
              <img src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span>
              <img src="././assets/icon/pieChartIcon.svg" alt="Pie Chart" class="cp">
            </span>
            <span class="cp" (click)="downloadGraph()">
              <img src="./assets/icon/downloadIcon.svg" alt="">
            </span>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <div class="formLabelRegularfs16   mb-5">
                    Year<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency6"
                    (selectionChange)="onYearChange($event.value,'six')">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="4">
                  <div class="formLabelRegularfs16   mb-5">
                    Month<span class="red-cl">&nbsp;*</span>
                  </div>
                  <mat-form-field class="mat-height40 w-100  mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedMonth6"
                    (selectionChange)="onMonthChange($event, 'six')">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                </ion-col>

              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div id="bar-line-approvedByFinance-chart" style="width: 100%; height: 400px;"></div>
      </ion-col>
    </div>
  </ion-col>

</ion-row>


<!-- <ion-row class="pt-10">
    <ion-col size="12">
      <div class="graphs card m-50">
        <ion-row class="align-items-center justify-content-between">
          <ion-col size-sm="12" size-md="10" size-lg="10" size-xs="12" class="text-start">
            <div class="fs-16 font_bold">How are you feeling today</div>
          </ion-col>
          <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12" class="d-flex justify-content-end">
            <div class="d-flex graph-icon">
              <span (click)="switchGraphType('bar')">
                <img *ngIf="graphType != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="">
                <img *ngIf="graphType == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
              </span>

              <span (click)="switchGraphType('line')">
                <img *ngIf="graphType != 'line'" src="./assets/icon/lineChartIcon.svg" alt="">
                <img *ngIf="graphType == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
              </span>

              <span class="cp" (click)="downloadGraph()">
                <img src="./assets/icon/downloadIcon.svg" alt="">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="pt-10">
          <ion-col size="5" size-md="5" size-lg="5" size-xs="12">
            <div class="sidebar-content">
              <ion-grid>
                <ion-row>
                  <ion-col size="6">
                    <label for="month" class="filter-label">Select Month:</label>
                    <ng-select class="filter-dropdown" [items]="months" bindLabel="name" bindValue="value"
                      [(ngModel)]="selectedMonth" placeholder="Select Month">
                    </ng-select>
                  </ion-col>

                  <ion-col size="6">
                    <label for="year" class="filter-label">Select Year:</label>
                    <ng-select class="filter-dropdown" [items]="years" bindLabel="year" bindValue="year"
                      [(ngModel)]="selectedYear" placeholder="Select Year">
                    </ng-select>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </ion-col>
        </ion-row>
        <div id="AgeGenderGraph" style="width: 100%; height: 400px;"></div>

      </div>
    </ion-col>
</ion-row> -->

<!-- 
<ion-row>
  <ion-col size="12" class="mt-10">
    <div class="font_semibold fs-16 mb-5">
      Required Range <span class="red-cl">*</span>
    </div>
  </ion-col>
  <ion-col size="12" *ngIf="!isLastMaxRange100()">
    <div class="font_semibold addnewbtn fs-14 cp" *ngIf="!showInputs" (click)="toggleInputs()">
      + Add New
    </div>
  </ion-col>
  <ion-col size="12" *ngIf="showInputs">
    <ion-row>
      <ion-col size="auto">
        <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
          Save
        </div>
      </ion-col>
      <ion-col size="auto">
        <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
          Remove
        </div>
      </ion-col>
    </ion-row>
  </ion-col>
  <ion-row *ngIf="showInputs" class="mb-15">
    <ion-col size="6">
      <div class="w-100 inputBox notAllowed">{{ scoreRange }}</div>
    </ion-col>
    <ion-col size="6">
      <mat-form-field class="w-100 mat-height40 mat-input-style">
        <input matInput [(ngModel)]="maxRange" type="number" placeholder="Max Range"
          class="font_regular fs-12" min="1"
          (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
          (keypress)="preventNegative($event)" />
      </mat-form-field>
      <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Max Range is required</div>
      <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">Max Range should be greater than Min Range</div>
    </ion-col>
  </ion-row>
</ion-row>
<ion-row>
  <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="mt-10">
    <div class="table-container">
      <table class="hover mb-5 custom-table">
        <thead>
          <tr>
            <th class="fs-14 font_bold cl-black">Lower End</th>
            <th class="fs-14 font_bold cl-black">Higher End</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of tableData">
            <td class="fs-14 font_regular">{{ item.lowerEnd }}</td>
            <td class="fs-14 font_regular">{{ item.higherEnd }}</td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
        {{ errorMessage }}
      </div>
    </div>
  </ion-col>
</ion-row> -->
